import { render, staticRenderFns } from "./PrivateConnect.vue?vue&type=template&id=ea96d216&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea96d216')) {
      api.createRecord('ea96d216', component.options)
    } else {
      api.reload('ea96d216', component.options)
    }
    module.hot.accept("./PrivateConnect.vue?vue&type=template&id=ea96d216&", function () {
      api.rerender('ea96d216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/PrivateConnect.vue"
export default component.exports